import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface IEmployeeFilterStrings extends LocalizedStringsMethods {
    lsInactiveTxt: string;
    lsActiveTxt: string;
    lsAllTxt: string;
    lsCSVTxt: string;
    lsManageEmpTxt: string;
    lsHomeTxt: string;
    lsEmpTxt: string;
    lsNoFilterTxt: string;
    lsClearFiltersTxt: string;
    lsUsrNameTxt: string;
    lsFNameTxt: string;
    lsLNameTxt: string;
    lsEmailTxt: string;
    lsRoleTxt: string;
    lsOrgTxt: string;
    lsAddEmpTxt: string;
    lsUploadEmpTxt: string;
    lsDwnldTxt: string;
    lsExportUsrTxt: string;
    lsOkTxt: string;
    lsExportEmpSuccessTxt: string;
    lsPrintTxt: string;
    lsEditTxt: string;
    lsEditEmpTxt: string;
    lsDeActivatedTxt: string;
    lsActivatedTxt: string;
    lsEmpActivationSuccessTxt: string;
    lsEmpAddSuccessTxt: string;
    lsEmpUpdateSuccessTxt: string;
    lsPassResetSuccessTxt: string;
    lsPassResetFailedTxt: string;
    lsEmpFilterTxt: string;
    lsFilterTxt: string;
    lsAddTxt: string;
    lsUsrNamePlaceholderTxt: string;
    lsUsrAlreadyExistTxt: string;
    lsFNamePlaceholderTxt: string;
    lsLNamePlaceholderTxt: string;
    lsEmailPlaceholderTxt: string;
    lsMobilePhoneTxt: string;
    lsMobilePhonePlaceholderTxt: string;
    lsSelectRoleTxt: string;
    lsSaveTxt: string;
    lsCancelTxt: string;
    lsConfirmPassResetTxt: string;
    lsConfirmPassResetInfoTxt: string;
    lsYesTxt: string;
    lsActionTxt: string;
    lsActivateTxt: string;
    lsDeActivateTxt: string;
    lsResetTxt: string;
    lsUsrPassCanResetTxt: string;
}

let strings: IEmployeeFilterStrings;
export default strings = new LocalizedStrings({
    en: {        
        lsInactiveTxt: 'Inactive Employees',
        lsActiveTxt: 'Active Employees',
        lsAllTxt: 'All Employees',
        lsCSVTxt: 'CSV',
        lsManageEmpTxt: 'Manage Employees',
        lsHomeTxt: 'Home',
        lsEmpTxt: 'Employees',
        lsNoFilterTxt: 'No filters applied',
        lsClearFiltersTxt: 'Clear Filters',
        lsUsrNameTxt: 'Username',
        lsFNameTxt: 'First Name',
        lsLNameTxt: 'Last Name',
        lsEmailTxt: 'Email',
        lsRoleTxt: 'Role',        
        lsOrgTxt: 'Organization',
        lsAddEmpTxt: 'Add Employee',
        lsUploadEmpTxt: 'Upload New Employees',
        lsDwnldTxt: 'Download',
        lsExportUsrTxt: 'Export User List',
        lsOkTxt: 'Ok', 
        lsExportEmpSuccessTxt: 'Employees exported successfully without tests!',   
        lsPrintTxt: 'Print',
        lsEditTxt: 'Edit',
        lsEditEmpTxt: 'Edit Employee',
        lsDeActivatedTxt: 'deactivated',
        lsActivatedTxt: 'activated',
        lsEmpActivationSuccessTxt: 'Employee {0} successfully!',
        lsEmpAddSuccessTxt: 'Employee added successfully!',
        lsEmpUpdateSuccessTxt: 'Employee updated successfully!',
        lsPassResetSuccessTxt: 'Password reset successfully!',
        lsPassResetFailedTxt: 'Password could not be reset. Please try again!',
        lsEmpFilterTxt: 'Employee List Filter',
        lsFilterTxt: 'Filter',
        lsAddTxt: 'Add',
        lsUsrNamePlaceholderTxt: 'e.g. jjohnson',
        lsUsrAlreadyExistTxt: 'Username already exists!',
        lsFNamePlaceholderTxt: 'e.g. Johnny',
        lsLNamePlaceholderTxt: 'eg Thomas',
        lsEmailPlaceholderTxt: 'eg johny.thomas@school.edu',
        lsMobilePhoneTxt: 'Mobile Phone',
        lsMobilePhonePlaceholderTxt: 'eg 0123-456-789',
        lsSelectRoleTxt: 'Select Role',
        lsSaveTxt: 'Save',
        lsCancelTxt: 'Cancel',
        lsConfirmPassResetTxt: 'Confirm password reset',
        lsConfirmPassResetInfoTxt: 'Are you sure you want to reset the password for',
        lsYesTxt: 'Yes',
        lsActionTxt: 'Action',
        lsActivateTxt: 'Activate',
        lsDeActivateTxt: 'Deactivate',
        lsResetTxt: 'Reset',
        lsUsrPassCanResetTxt: 'User password can be reset'
    },
    es: {        
        lsInactiveTxt: 'Inactive Employees',
        lsActiveTxt: 'Active Employees',
        lsAllTxt: 'All Employees',
        lsCSVTxt: 'CSV',
        lsManageEmpTxt: 'Manage Employees',
        lsHomeTxt: 'Home',
        lsEmpTxt: 'Employees',
        lsNoFilterTxt: 'No filters applied',
        lsClearFiltersTxt: 'Clear Filters',
        lsUsrNameTxt: 'Username',
        lsFNameTxt: 'First Name',
        lsLNameTxt: 'Last Name',
        lsEmailTxt: 'Email',
        lsRoleTxt: 'Role',        
        lsOrgTxt: 'Organization',
        lsAddEmpTxt: 'Add Employee',
        lsUploadEmpTxt: 'Upload New Employees',
        lsDwnldTxt: 'Download',
        lsExportUsrTxt: 'Export User List',
        lsOkTxt: 'Ok', 
        lsExportEmpSuccessTxt: 'Employees exported successfully without tests!',   
        lsPrintTxt: 'Print',
        lsEditTxt: 'Edit',
        lsEditEmpTxt: 'Edit Employee',
        lsDeActivatedTxt: 'deactivated',
        lsActivatedTxt: 'activated',
        lsEmpActivationSuccessTxt: 'Employee {0} successfully!',
        lsEmpAddSuccessTxt: 'Employee added successfully!',
        lsEmpUpdateSuccessTxt: 'Employee updated successfully!',
        lsPassResetSuccessTxt: 'Password reset successfully!',
        lsPassResetFailedTxt: 'Password could not be reset. Please try again!',
        lsEmpFilterTxt: 'Employee List Filter',
        lsFilterTxt: 'Filter',
        lsAddTxt: 'Add',
        lsUsrNamePlaceholderTxt: 'e.g. jjohnson',
        lsUsrAlreadyExistTxt: 'Username already exists!',
        lsFNamePlaceholderTxt: 'e.g. Johnny',
        lsLNamePlaceholderTxt: 'eg Thomas',
        lsEmailPlaceholderTxt: 'eg johny.thomas@school.edu',
        lsMobilePhoneTxt: 'Mobile Phone',
        lsMobilePhonePlaceholderTxt: 'eg 0123-456-789',
        lsSelectRoleTxt: 'Select Role',
        lsSaveTxt: 'Save',
        lsCancelTxt: 'Cancel',
        lsConfirmPassResetTxt: 'Confirm password reset',
        lsConfirmPassResetInfoTxt: 'Are you sure you want to reset the password for',
        lsYesTxt: 'Yes',
        lsActionTxt: 'Action',
        lsActivateTxt: 'Activate',
        lsDeActivateTxt: 'Deactivate',
        lsResetTxt: 'Reset',
        lsUsrPassCanResetTxt: 'User password can be reset'
     }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/employee/strings.employee.filter.tsx